/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RecourseBookingDto } from '../../models/recourse-booking-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetRecourseBookingDetails$Params {
  recourseBookingId: number;
  isEditMode?: boolean;
}

export function getRecourseBookingDetails(
  http: HttpClient,
  rootUrl: string,
  params: GetRecourseBookingDetails$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RecourseBookingDto>> {
  const rb = new RequestBuilder(rootUrl, getRecourseBookingDetails.PATH, 'get');
  if (params) {
    rb.path('recourseBookingId', params.recourseBookingId, {});
    rb.query('isEditMode', params.isEditMode, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecourseBookingDto>;
    }),
  );
}

getRecourseBookingDetails.PATH = '/service/v1/recoursebooking/{recourseBookingId}';
